module.exports = __webpack_public_path__ + "static/img/gif0.2124ae9e.gif";